import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Title, Overview } from 'components/misc'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import styles from '../Header/header.styl'
const actOverviewMock = { loading: false }

class AwardSummaryHeader extends PureComponent {
  static propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    downloadButton: PropTypes.any,
    secondaryDownloadButton: PropTypes.any,
    tertiaryDownloadButton: PropTypes.any
  }

  render() {
    const { startDate, endDate, downloadButton, secondaryDownloadButton, tertiaryDownloadButton } = this.props

    return (
      <div>
        <Title
          style={{ color: '#4e4e4e', fontWeight: 'bold' }}
          h2
          intlKey="label.award_summary"
        >
          Award Summary
        </Title>

        <div className="row">
          <div className="col-xs-12 col-md-6">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={ACTIVITY_SECTIONS.skill.id}
              content={[
                {
                  id: '00',
                  content: startDate,
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                }
              ]}
            />

          </div>

          <div className="col-xs-12 col-md-6">
            <Overview
              activityOverview={actOverviewMock}
              activitySection={ACTIVITY_SECTIONS.skill.id}
              content={[
                {
                  id: '00',
                  content: endDate,
                  intlKey: 'label.completion_date',
                  label: 'Completion Date',
                  ico: 'date',
                  date: endDate !== '---'
                }
              ]}
            />
          </div>
        </div>
        <div className="row">
          <div className={styles.downloadWrapper}>
            <div className={styles.downloadButton}>{downloadButton}</div>
            <div className={styles.downloadButton}>{secondaryDownloadButton}</div>
          </div>
        </div>
        <div className="row">
          <div  className={styles.downloadWrapper}>
            <div className={styles.downloadButton}>{tertiaryDownloadButton}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default AwardSummaryHeader
